export default "__VITE_ASSET__b3ee5e06__"